<template>
  <v-layout>
    <v-row>
      <v-col cols="12" md="3" xl="2">
        <v-card>
          <v-card-title>
            Filtry
          </v-card-title>
          <v-card-text>
            <CodesFilters></CodesFilters>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" md="9" xl="10">
        <v-card>
          <v-card-title>
            Lista kodów
          </v-card-title>
          <v-card-text>
            <Codes></Codes>
            <div class="text-center">
              <v-btn
                  class="mx-2"
                  @click="add"
              >
                Dodaj nowy kod
              </v-btn>
              <v-btn
                  class="mx-2"
                  @click="refresh"
              >
                Odśwież
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-layout>
</template>

<script>
import Codes from "@/components/codes/Codes";
import CodesFilters from "@/components/codes/CodesFilters";

export default {
  components: {
    Codes,
    CodesFilters,
  },
  data() {
    return {
      loading: false,
    }
  },
  computed: {},
  methods: {
    add() {
      this.$router
          .push({name: 'codes-add'})
          .catch(() => {
          });
    },
    refresh() {
      const self = this;
      this.$root.$emit('loadCodes', {
        onSuccess: () => {
          self.$root.$emit('notify', {
            html: 'Lista została odświeżona.',
          });
        }
      });
    },
  },
}
</script>